// App Imports
import params from '../../../setup/config/params'
import List from '../List'
import CreateOrUpdate from '../CreateOrUpdate'
import AiBlog from '../AiBlog'

// Pages routes
const routes = {
  cmsList: {
    path: '/cms',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "resource",
    action:"canView",
    requiresResourceEnabled: true,
  },
  cmsCreate: {
    path: '/cms/create',
    component: CreateOrUpdate,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "resource",
    action:"canCreate",
    requiresResourceEnabled: true,
  },
  cmsEdit: {
    path: (cmsId = ':cmsId') => (`/cms/edit/${ cmsId }`),
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "resource",
    action:"canEdit",
    requiresResourceEnabled: true,
  },
  cmsAiBlog: {
    path: '/cms/ai-blog',
    component: AiBlog,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "resource",
    action: "canCreate",
    requiresResourceEnabled: true,
  },
}
export default routes;